import moment from 'moment';
import './date.styles.scss';

const Date = () => {
  return (
    <div className='date-container'>
      <p className='week-day'>{moment().format('dddd')}</p>
      <p className='date'>{moment().format('MMMM D, YYYY')}</p>
    </div>
  );
};

export default Date;
